import styled from "styled-components";
export const MealWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
